import * as enableActions from '../actions/enable-consent.actions';
import { EnableConsent } from '../model/enable-consent.model';
import { AuthorizationModal } from '../../../core/model/authorization/authorization-modal.model';

/**
 * Reducer handles authorization object returned from API when enabling consent
 * (disabling consent does not require authorization process).
 *
 * - authorization - returned by API when enabling consent
 * - authorizationResponse - message posted by MEP IFrame authorization
 */
export function enableConsentAuth(state: AuthorizationModal<EnableConsent> = null, action: enableActions.Actions): AuthorizationModal<EnableConsent> {
    switch (action.type) {
        case enableActions.ENABLE_CONSENT_SUCCESS:
            return {...state, shown: true, authorization: action.payload};
        case enableActions.ENABLE_CONSENT_CANCEL:
        case enableActions.ENABLE_CONSENT_CLEAN:
        case enableActions.ENABLE_CONSENT_AUTH_ERROR:
            return {...state, shown: false, authorization: null, authorizationResponse: null};
        case enableActions.ENABLE_CONSENT_AUTH_FINISHED:
            return {...state, shown: false, authorizationResponse: action.payload};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/consent/reducers/enable-consent-auth.reducer.ts